import {JSONCensus} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {PageOf} from "../../../processes/massive_actions/CensusCooler/data/models/PageOf";
import {
    UseFetchInfiniteHookProps
} from "../../../processes/massive_actions/CensusCooler/data/models/UseFetchInfiniteHookProps";
import useSWRInfinite from "swr/infinite";
import * as React from "react";
import {concatenateApiPaginatedResponse} from "../../../processes/massive_actions/CensusCooler/data/utils";
import {fetchCensusList} from "../controllers/CensusController";
import {uuid} from "../../../types/veboxModels";
import useSWR from "swr";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {getBaseUrl} from "../../../processes/massive_actions/CensusCooler/data/controllers/CensusCoolerController";
import {JSONCensusFinalSummary} from "../models/JSONCensusFinalSummary";


export type UseFetchCensusListInfiniteHookProps =
    UseFetchInfiniteHookProps<PageOf<JSONCensus>, JSONCensus>;

export interface CensusListInfiniteHookProps {
    page: number;
    size: number;
}

export const useCensusListInfinite = (
    params: CensusListInfiniteHookProps,
): UseFetchCensusListInfiniteHookProps => {
    const swrKey = (index: number) => ({
        ...params,
        page: index,
    });

    const {data, error, setSize, isLoading, isValidating, size, mutate} =
        useSWRInfinite<PageOf<JSONCensus>, Error>(
            swrKey,
            fetchCensusList,
            {
                revalidateFirstPage: false,
                revalidateAll: false,
                revalidateIfStale: false,
                revalidateOnFocus: true,
            },
        );

    const isFetching = isLoading;

    const concatenatedData = React.useMemo(
        () => data ? concatenateApiPaginatedResponse(data) : [],
        [data],
    );

    const isNextPageLoading = isValidating;

    const handleOnLoadNextPage = async (startIndex?: number) => {
        if (startIndex === undefined) {
            await setSize(0);
        }
        await setSize(startIndex + 1);
    };

    return {
        mutate,
        lastPageInfo: data?.[data?.length - 1],
        flattenedData: concatenatedData.length ? concatenatedData : [],
        error,
        isNextPageLoading,
        isFetching,
        handleOnLoadNextPage,
        totalCount: data?.[0]?.totalElements ?? 0,
        size,
        hasNextPage: data?.[data?.length - 1]?.last === false,
    };
};


export function useCensusDetail(
    censusGuid?: uuid,
    shouldFetch?: boolean,
) {
    const configuration = {
        url: `${getBaseUrl(censusGuid)}`,
    };
    return useSWR<JSONCensus, Error>(
        shouldFetch ? configuration : null,
        RestDataLoader.fetchData,
    );
}

export function useCensusFinalSummary(
    censusGuid: uuid,
    shouldFetch: boolean,
) {
    const configuration = {
        url: `${getBaseUrl(censusGuid)}finalSummary`,
        params: {},
    };
    return useSWR<JSONCensusFinalSummary, Error>(
        shouldFetch ? configuration : null,
        RestDataLoader.fetchData,
    );
}